// extracted by mini-css-extract-plugin
export default {"move":"MoveToTop_move__kFkjL"};